import { ChangeDetectorRef, HostBinding, Input } from "@angular/core";

import { AttributePresenceInput } from "@spscommerce/ng-utils";

export class PinnableTableCell {
    static readonly props = {
        pinned: "boolean",
    };

    protected changeDetector: ChangeDetectorRef;

    @HostBinding("style.left")
    pinLeft = "";

    @HostBinding("style.right")
    pinRight = "";

    @Input()
    @AttributePresenceInput()
    @HostBinding("class.sps-table__cell--pinned")
    pinned: boolean;

    setPinPosition(left: string, right: string) {
        this.pinLeft = left;
        this.pinRight = right;
        this.changeDetector.markForCheck();
    }
}
